const toggleNavbar = () => {
  const nav = document.getElementById('navbar');
  const main = document.getElementById('main');

  nav?.classList.toggle('open');
  main?.classList.toggle('full-screen');
};

export default toggleNavbar;
